import { getCachedJson, setCachedJson } from './db';

function stableStringify(obj) {
  if (!obj) return '';
  try {
    // axios params can be URLSearchParams or objects
    if (obj instanceof URLSearchParams) return obj.toString();
    if (typeof obj === 'string') return obj;
    const keys = Object.keys(obj).sort();
    const normalized = {};
    for (const k of keys) {
      const v = obj[k];
      normalized[k] = v;
    }
    return JSON.stringify(normalized);
  } catch {
    return '';
  }
}

export function buildCacheKeyFromAxiosConfig(config) {
  const baseURL = config.baseURL || '';
  const url = config.url || '';
  const full = `${baseURL}${url}`;

  // Prefer explicit params; for already-built URLs keep them
  const paramsStr = config.params ? stableStringify(config.params) : '';
  const hasQuery = full.includes('?');
  if (paramsStr && !hasQuery) {
    return `${full}?__p=${encodeURIComponent(paramsStr)}`;
  }
  if (paramsStr && hasQuery) {
    return `${full}&__p=${encodeURIComponent(paramsStr)}`;
  }
  return full;
}

export async function cacheGetResponse(cacheKey, data) {
  await setCachedJson(cacheKey, data);
}

export async function getCachedResponse(cacheKey) {
  return await getCachedJson(cacheKey);
}

